import { ModeloBase } from "./modeloBase"


// CREATE TABLE sop.tbl_tela_sop_finance (
//   cod_tela_sop_finance serial primary key,
//   des_time date NULL,
//   cod_business_unit int4 NULL,
 
//   cod_product int4 NULL,
 

//   num_selling_price_real numeric NULL,
//   num_selling_price_forecast numeric NULL,
//   num_selling_price_budget numeric NULL,
//   num_unit_cogs_real numeric NULL,
//   num_unit_cogs_forecast numeric NULL,
//   num_unit_cogs_budget numeric null,
//  num_gross_margin_real numeric null,
//   num_gross_margin_forecast numeric null,
//     num_gross_margin_budget numeric null
 
// );


export class ModeloSopFinance extends ModeloBase {
  cod_tela_sop_finance?: number // SERIAL PRIMARY KEY
  des_time?: string // Pode ser string se for uma data ou tipo adequado
  cod_business_unit?: number
  cod_product?: number;

  num_selling_price_real?: number;
  num_selling_price_forecast?: number;
  num_selling_price_budget?: number;
  num_unit_cogs_real?: number;
  num_unit_cogs_forecast?: number;
  num_unit_cogs_budget?: number;

  num_gross_margin_real?: number;
  num_gross_margin_forecast?: number;
  num_gross_margin_budget?: number;

  des_product?: string;
  des_business_unit?: string;

}
